import tw, { styled } from "twin.macro"

export const CardContent = styled.div`
  ${[tw`p-5`, tw`desktop:(flex flex-col)`]}
`
